// Axion Elite — StaggeredMenu-style header nav panel (GSAP-driven, vanilla JS port)

(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasGsap = typeof gsap !== 'undefined';

  function init() {
    var toggle = document.getElementById('axion-toggle');
    var panel = document.getElementById('axion-nav-panel');
    var textInner = document.getElementById('axion-toggle-text-inner');
    var header = document.querySelector('.site-header');
    if (!toggle || !panel || !textInner || !header) return;

    var prelayers = Array.prototype.slice.call(header.querySelectorAll('.site-header__prelayer'));
    var iconH = toggle.querySelector('.site-header__toggle-icon-line--h');
    var iconV = toggle.querySelector('.site-header__toggle-icon-line--v');

    // Panel content is static Liquid output — query once and reuse, rather than
    // re-querying the DOM on every open/close cycle.
    var items = panel.querySelectorAll('.site-header__panel-link-label');
    var numbers = panel.querySelectorAll('.site-header__panel-list[data-numbering] .site-header__panel-link');
    var socialsTitleEl = panel.querySelector('.site-header__socials-title');
    var socialsLinks = panel.querySelectorAll('.site-header__socials-link');

    var open = false;
    var openTl = null;
    var closeTween = null;
    var textCycleTween = null;

    function resetPanelContent() {
      if (items.length) gsap.set(items, { yPercent: 140, rotate: 10 });
      if (numbers.length) gsap.set(numbers, { '--sm-num-opacity': 0 });
      if (socialsTitleEl) gsap.set(socialsTitleEl, { opacity: 0 });
      if (socialsLinks.length) gsap.set(socialsLinks, { y: 25, opacity: 0 });
    }

    if (hasGsap) {
      // `x: 0` is required alongside `xPercent` here: the CSS fallback (`transform:
      // translateX(100%)`, used when JS/GSAP is unavailable) resolves to a pixel value
      // that GSAP would otherwise parse into its internal `x` cache on first touch,
      // then add `xPercent`'s own offset on top of — doubling the translation.
      // Pinning `x: 0` explicitly overrides that parsed baseline so `xPercent` is the
      // sole driver from here on.
      gsap.set([panel].concat(prelayers), { x: 0, xPercent: 100 });
      gsap.set(iconH, { transformOrigin: '50% 50%', rotate: 0, y: 0 });
      gsap.set(iconV, { transformOrigin: '50% 50%', rotate: 90, y: 0 });
      gsap.set(textInner, { yPercent: 0 });
      resetPanelContent();
    }

    function buildOpenTimeline() {
      // Kill whatever's in flight in either direction before building the new one —
      // this is what makes re-triggering safe without a separate "busy" guard.
      openTl && openTl.kill();
      closeTween && closeTween.kill();
      closeTween = null;

      resetPanelContent();

      var tl = gsap.timeline({ paused: true });

      prelayers.forEach(function (el, i) {
        tl.fromTo(el, { xPercent: 100 }, { xPercent: 0, duration: 0.5, ease: 'power4.out' }, i * 0.07);
      });
      var lastTime = prelayers.length ? (prelayers.length - 1) * 0.07 : 0;
      var panelInsertTime = lastTime + (prelayers.length ? 0.08 : 0);
      var panelDuration = 0.65;
      tl.fromTo(panel, { xPercent: 100 }, { xPercent: 0, duration: panelDuration, ease: 'power4.out' }, panelInsertTime);

      if (items.length) {
        var itemsStart = panelInsertTime + panelDuration * 0.15;
        tl.to(items, { yPercent: 0, rotate: 0, duration: 1, ease: 'power4.out', stagger: { each: 0.1, from: 'start' } }, itemsStart);
        if (numbers.length) {
          tl.to(numbers, { duration: 0.6, ease: 'power2.out', '--sm-num-opacity': 1, stagger: { each: 0.08, from: 'start' } }, itemsStart + 0.1);
        }
      }

      if (socialsTitleEl || socialsLinks.length) {
        var socialsStart = panelInsertTime + panelDuration * 0.4;
        if (socialsTitleEl) tl.to(socialsTitleEl, { opacity: 1, duration: 0.5, ease: 'power2.out' }, socialsStart);
        if (socialsLinks.length) {
          tl.to(socialsLinks, {
            y: 0,
            opacity: 1,
            duration: 0.55,
            ease: 'power3.out',
            stagger: { each: 0.08, from: 'start' },
            onComplete: function () { gsap.set(socialsLinks, { clearProps: 'opacity' }); }
          }, socialsStart + 0.04);
        }
      }

      openTl = tl;
      return tl;
    }

    function playOpen() {
      var tl = buildOpenTimeline();
      tl.play(0);
    }

    function playClose() {
      openTl && openTl.kill();
      openTl = null;

      var all = prelayers.concat([panel]);
      closeTween && closeTween.kill();
      closeTween = gsap.to(all, {
        xPercent: 100,
        duration: 0.32,
        ease: 'power3.in',
        overwrite: 'auto',
        onComplete: function () {
          panel.classList.remove('is-open');
          resetPanelContent();
        }
      });
    }

    function animateIcon(opening) {
      gsap.killTweensOf([iconH, iconV]);
      if (opening) {
        gsap.to(iconH, { rotate: 45, y: 4, duration: 0.4, ease: 'power4.out', overwrite: 'auto' });
        gsap.to(iconV, { rotate: -45, y: -4, duration: 0.4, ease: 'power4.out', overwrite: 'auto' });
      } else {
        gsap.to(iconH, { rotate: 0, y: 0, duration: 0.35, ease: 'power3.inOut', overwrite: 'auto' });
        gsap.to(iconV, { rotate: 90, y: 0, duration: 0.35, ease: 'power3.inOut', overwrite: 'auto' });
      }
    }

    function setToggleText(label) {
      textInner.innerHTML = '';
      var span = document.createElement('span');
      span.className = 'site-header__toggle-line';
      span.textContent = label;
      textInner.appendChild(span);
    }

    function animateText(opening) {
      textCycleTween && textCycleTween.kill();

      var currentLabel = opening ? 'Menu' : 'Close';
      var targetLabel = opening ? 'Close' : 'Menu';
      var seq = [currentLabel];
      var last = currentLabel;
      for (var i = 0; i < 3; i++) {
        last = last === 'Menu' ? 'Close' : 'Menu';
        seq.push(last);
      }
      // With exactly two alternating labels and an odd flip count, `last` is
      // already `targetLabel` here — the sequence ends correctly without
      // appending anything further.

      textInner.innerHTML = '';
      seq.forEach(function (label) {
        var span = document.createElement('span');
        span.className = 'site-header__toggle-line';
        span.textContent = label;
        textInner.appendChild(span);
      });

      gsap.set(textInner, { yPercent: 0 });
      var lineCount = seq.length;
      var finalShift = ((lineCount - 1) / lineCount) * 100;
      textCycleTween = gsap.to(textInner, { yPercent: -finalShift, duration: 0.5 + lineCount * 0.07, ease: 'power4.out' });
    }

    function setInstantState(opening) {
      if (hasGsap) {
        gsap.set([panel].concat(prelayers), { xPercent: opening ? 0 : 100 });
        if (opening) {
          if (items.length) gsap.set(items, { yPercent: 0, rotate: 0 });
          if (numbers.length) gsap.set(numbers, { '--sm-num-opacity': 1 });
          if (socialsTitleEl) gsap.set(socialsTitleEl, { opacity: 1 });
          if (socialsLinks.length) gsap.set(socialsLinks, { y: 0, opacity: 1 });
        } else {
          resetPanelContent();
        }
        gsap.set(iconH, { rotate: opening ? 45 : 0, y: opening ? 4 : 0 });
        gsap.set(iconV, { rotate: opening ? -45 : 90, y: 0 });
      }
      setToggleText(opening ? 'Close' : 'Menu');
    }

    function getFocusableEls() {
      return [toggle].concat(Array.prototype.slice.call(panel.querySelectorAll('a[href]')));
    }

    function openMenu() {
      open = true;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close navigation menu');
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      panel.removeAttribute('inert');

      if (prefersReducedMotion || !hasGsap) {
        setInstantState(true);
        return;
      }
      playOpen();
      animateIcon(true);
      animateText(true);
    }

    function closeMenu(options) {
      open = false;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open navigation menu');
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');

      var instant = (options && options.instant) || prefersReducedMotion || !hasGsap;
      if (instant) {
        openTl && openTl.kill();
        openTl = null;
        closeTween && closeTween.kill();
        closeTween = null;
        panel.classList.remove('is-open');
        setInstantState(false);
        return;
      }
      playClose();
      animateIcon(false);
      animateText(false);
    }

    toggle.addEventListener('click', function () {
      if (open) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    panel.addEventListener('click', function (event) {
      if (open && event.target.closest('.site-header__panel-link, .site-header__socials-link')) {
        closeMenu();
      }
    });

    document.addEventListener('mousedown', function (event) {
      if (!open) return;
      if (panel.contains(event.target) || toggle.contains(event.target)) return;
      closeMenu();
    });

    document.addEventListener('keydown', function (event) {
      if (!open) return;

      if (event.key === 'Escape') {
        closeMenu({ instant: true });
        toggle.focus();
        return;
      }

      if (event.key === 'Tab') {
        var focusable = getFocusableEls();
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
